import React, { useEffect, useRef, useState } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { useParams } from 'react-router-dom';
import { API_URL, BASE_URL } from '../Config';
import config from "../common/Config";
import jsPDF from 'jspdf';  // Library to generate PDF
import 'jspdf-autotable';  // Plugin for auto table
import printPurchaseOrderInvoice from './generateSummaryPDF_dds';
const PurchaseViewPrint = (props) => {
	const { orderId } = useParams();

	const [productData, setProductData] = useState([]);
	const [shopDetails, setShopDetails] = useState([]);
	const [commonData, setCommonData] = useState([]);
	const [totalVal, setTotalVal] = useState(
		{
			grandTotal: 0,
		}
	);

	const accessToken = localStorage.getItem('accessToken');
	const company_tax_type = localStorage.getItem("company_tax_type");
	const currencySymbol = localStorage.getItem("currencySymbol");


	const fetchProductInfo = async () => {
		const formData = new FormData();
		formData.append('id', orderId);
		const apiUrl = `${API_URL}/purchases/getpurches_items`;
		try {
			const response = await fetch(apiUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});

			if (!response.ok) {
				throw new Error('Failed to fetch Not Order Report');
			}
			const data = await response.json();
			setCommonData(data.commonData[0]);
			setShopDetails(data.shop_details);
			setProductData(data.purchase);


			const grandTotal = data.purchase.reduce((acc, item) => {
				const pdtVat = (parseFloat(item.unit_cost) * parseFloat(item.quantity)) * parseFloat(item.rate) / 100;
				const stotal = parseFloat(item.unit_cost) * parseFloat(item.quantity);
				const pdtTotal = pdtVat + stotal;
				return acc + pdtTotal;
			}, 0);

			// Update state with grand total
			setTotalVal({ grandTotal: formatNumber(grandTotal) });


		} catch (error) {
			console.error('api fail Error fetching Not Order Report:', error);
		}
	};

	useEffect(() => {

		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}
		fetchProductInfo();
	}, [accessToken]);

	const formatNumber = (num) => {
		return parseFloat(num).toFixed(2);
	};
	const handleGenerateDeliveryNotePDF = (e, orderId) => {

		printPurchaseOrderInvoice(orderId);

	}
	useEffect(() => {
		const table = $('#productDetails').DataTable({
			pageLength: 50,
			paging: false,
			lengthMenu: [10, 20, 50],
			searching: false,
			ordering: false,
			info: false,
			responsive: true,
			autoWidth: false,
			data: productData,
			columns: [
				{
					data: null,
					render: function (data, type, row) {
						return `<span>${row.product_code} - ${row.product_name}</span> `;
					}
				},
				{
					data: null,
					className: 'text-center',
					render: function (data, type, row) {
						return `<span>${parseInt(row.quantity)}</span>`
					}
				},
				{
					data: null,
					className: 'text-center',
					render: function (data, type, row) {
						return row.unit_cost ? `<span>${currencySymbol} ${formatNumber(row.unit_cost)}</span>` : `<span>£ 0.00</span>`;
					}
				},
				{
					data: 'rate',
					className: 'text-center',
					render: function (data, type, row) {
						const pdtVat = (row.unit_cost * row.quantity) * row.rate / 100;
						return pdtVat ? `<span>${currencySymbol} ${formatNumber(pdtVat)}</span>` : `<span>0.00</span>`;
					}
				},
				{
					data: null,
					className: 'text-center',
					render: function (data, type, row) {

						const pdtVat = (row.unit_cost * row.quantity) * row.rate / 100;
						const stotal = row.unit_cost * row.quantity;
						const pdtTotal = pdtVat + stotal;

						return `<span>${currencySymbol} ${formatNumber(pdtTotal)}</span>`;
					}
				},

			],
			columnDefs: [
				{
					targets: [0],
					orderable: false
				}
			],
			drawCallback: function (settings) {
				var api = this.api();


			}
		});
		return () => {
			table.destroy();
		};
	}, [productData]);


	const generatePDF = () => {
		const doc = new jsPDF();

		// Header
		const header = [
			[`${shopDetails.shop_name}`, `PLEASE PHONE THE`],
			[`${shopDetails.address}`, `OFFICE TO PAY BY`],
			[`TEL : ${shopDetails.phone}`, `CREDIT/DEBIT CARD`],
			[`VAT NO : ${shopDetails.vat_no}`, `Bank A/C: ${shopDetails.bank_ac}`],
			[`COMPANY REG NO: ${shopDetails.company_reg_no}`, `Sort Code: ${shopDetails.sort_code}`],
		];

		// Define columns for autoTable
		const columns = [
			{ title: 'Description', dataKey: 'description' },
			{ title: 'Quantity', dataKey: 'quantity' },
			{ title: 'Type', dataKey: 'type' },
			// { title: 'Unit Cost', dataKey: 'unit_cost' },
			// { title: 'Tax', dataKey: 'tax' },
			// { title: 'Subtotal', dataKey: 'subtotal' },
		];

		// Prepare data for the table
		let qty = 0;
		const tableData = productData.map(item => {
			qty += parseInt(item.quantity, 10);
			// Declare type variable before the return statement
			let type;

			// Set the value of type based on the item.type
			if (item.type === '1') {
				type = 'Pic';  // Set type as 'Pic' if item.type is '1'
			} else {
				type = 'Box';  // Set a default type if item.type is not '1'
			}

			// Return the transformed data object
			return {
				description: `${item.product_code} - ${item.product_name} - ${item.size}`,
				quantity: parseInt(item.quantity, 10), // Parse quantity as an integer
				type: type,
				// unit_cost: `£ ${formatNumber(item.unit_cost)}`, // Uncomment if needed
				// tax: `£ ${formatNumber(item.tax)}`, // Uncomment if needed
				// subtotal: `£ ${formatNumber(item.total)}` // Uncomment if needed
			};
		});

		// Add header to the document
		doc.autoTable({
			head: header,
			startY: 10,
			headStyles: { fontSize: 10 },
			margin: { top: 20 },
			showHead: 'firstPage',
		});

		// Add table body
		const itemsPerPage = 25;
		const totalPages = Math.ceil(tableData.length / itemsPerPage);

		for (let i = 0; i < totalPages; i++) {
			const startIndex = i * itemsPerPage;
			const endIndex = startIndex + itemsPerPage;
			const pageData = tableData.slice(startIndex, endIndex);

			if (i > 0) {
				doc.addPage();
			}

			doc.autoTable({
				columns: columns,
				body: pageData,
				startY: doc.previousAutoTable.finalY + 10 || 20,
				styles: { fontSize: 10 },
			});

			// Add footer only on the last page
			if (i === totalPages - 1) {
				const endY = doc.previousAutoTable.finalY;
				doc.autoTable({
					startY: endY + 10,
					body: [[`Total :  ${qty}`]],
					styles: { fontSize: 10, halign: 'right' },
				});
			}
		}
		// Save the PDF
		doc.save(`invoice_${commonData.supplierId}.pdf`);
	};
	let status = '';
	if (commonData.status === 'Draft') {
	status = 'Order';
	} else if (commonData.status === 'Close') {
	status = 'Received';
	} else {
	status = ''; // default or other statuses
	}
	return (
		<>
			<Header />
			<div className="breadcrumbs">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12 col-lg-12 col-sm-12">
							<Link to="/Dashboard"><i className="fa fa-home"></i></Link>

							<span className="last-crumb">Purchases view</span>
						</div>
					</div>
				</div>
			</div>
			<div className="main-container">
				<div className="container-fluid">

					<div className="row">
						<div class="col-12">
							<button className='btn btn-success btn-sm' style={{ margin: '10px' }}
								onClick={(e) => handleGenerateDeliveryNotePDF(e, orderId)}>
								Print
							</button>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="show-order-area dashboard">
								<div className="sales-view-area">

									<div className="row page-header" style={{ paddingTop: '10px' }}>
										<div className="col-4">
											<h6>
												<span>{commonData.name}</span>
											</h6>
											<p>
												<span>{commonData.note}</span>
											</p>
											<p>
												<span>Tel : {commonData.phone}</span>
											</p>
											<p>
												<span>Email : {commonData.email}</span>
											</p>
												<p>
												<span>{company_tax_type} : {commonData.vat_no}</span>
											</p>
											
										</div>
										<div className="col-4">
											<h6>
												<span>{shopDetails.shop_name}</span>
											</h6>
											<p>
												<span>{shopDetails.address}</span>
											</p>

										</div>
										<div className="col-4">
											<h6>
												<span>Reference : {commonData.reference_no}</span>
											</h6>
											<p>
												<span>Date : {commonData.date}</span>
											</p>
											
											
										</div>
									</div>
									<table className="table table-bordered dataTable resizable" id="productDetails">
										<thead>
											<tr>
												<th>Description</th>
												<th>Quanitiy</th>
												<th>Unit Cost</th>
												<th>{company_tax_type}</th>
												<th>Subtotal</th>
											</tr>
										</thead>
										<tbody>
										</tbody>
										<tfoot>
										
											<tr>
												<td colSpan="4" className="text-end" >
													<span className="text-end">Total</span>
												</td>
												<td><span>{currencySymbol} {totalVal.grandTotal}</span></td>
											</tr>
										</tfoot>
									</table>
									{/* <h3>
										<span>Created by : </span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span>Date : </span>
									</h3> */}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);

}
export default PurchaseViewPrint;